// Texts of the draft (onboarding) writes of the shared client dashboard: server error codes in plain language. Arabic first, English.

export const ONBOARDING_TEXT = {
  ar: {
    errors: { ONBOARDING_LOCKED: "لا يمكن تعديل البيانات في حالتها الحالية.", INCOMPLETE: "البيانات غير مكتملة بعد.", NETWORK: "تعذر الاتصال بالخادم." },
    errorFallback: "تعذر تنفيذ العملية.",
  },
  en: {
    errors: { ONBOARDING_LOCKED: "The details cannot be edited in their current status.", INCOMPLETE: "The details are not complete yet.", NETWORK: "Could not reach the server." },
    errorFallback: "The operation failed.",
  },
};
